<template>
  <WrappingComponent :settings="settings" :formData="form" />
</template>

<script>
export default {
  name: "TermsAndPolicy",
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    WrappingComponent: () => import("./WrappingComponent")
  },

  data() {
    return {
      form: {
        terms_and_conditions: "",
        usage_policy: "",
        about: ""
      }
    };
  }
};
</script>
